<template>
    <app-main>
        <app-content>

             <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Settings"
                        sub-title="Control your website"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="theme" :handle-click="toggle" :active="active">Theme</app-tabs-trigger>
                    <app-tabs-trigger name="info" :handle-click="toggle" :active="active">Info box</app-tabs-trigger>
                </div>
                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">
                        <app-field-text
                            label="Site Title"
                            v-model="fields.site_title"
                            :error="errors.site_title"
                        />

                        <app-field-select
                            label="Default Language"
                            :items="items.locales"
                            v-model="fields.default_language"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.default_language"
                        />

                        <div class="block my-8 w-full bg-grey-light" style="height: 1px;"></div>

                        <h3 class="mb-3">Pages</h3>

                        <app-field-select
                            label="Landing Page"
                            :items="pages"
                            v-model="fields.homepage"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.homepage"
                        />

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services - landing page"
                                    :items="pages"
                                    v-model="fields.services_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services detail page"
                                    :items="pages"
                                    v-model="fields.services_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_detail"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services Thank You page"
                                    :items="pages"
                                    v-model="fields.services_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_thank_you"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services Contact thank you page"
                                    :items="pages"
                                    v-model="fields.services_contact_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_contact_thank_you"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services Commerial - landing page"
                                    :items="pages"
                                    v-model="fields.services_commercial_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_commercial_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services Commercial - detail page"
                                    :items="pages"
                                    v-model="fields.services_commercial_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_commercial_detail"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services Commercial - Thank You page"
                                    :items="pages"
                                    v-model="fields.services_commercial_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_commercial_thank_you"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Services Commercial - Contact thank you page"
                                    :items="pages"
                                    v-model="fields.services_commercial_contact_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.services_commercial_contact_thank_you"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Offers - landing page"
                                    :items="pages"
                                    v-model="fields.offers_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.offers_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Offers detail page"
                                    :items="pages"
                                    v-model="fields.offers_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.offers_detail"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Offers - booking request thank you page"
                                    :items="pages"
                                    v-model="fields.offers_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.offers_thank_you"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Careers - landing page"
                                    :items="pages"
                                    v-model="fields.careers_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.careers_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Careers detail page"
                                    :items="pages"
                                    v-model="fields.careers_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.careers_detail"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Locate a centre - landing page"
                                    :items="pages"
                                    v-model="fields.locate_a_centre_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.locate_a_centre_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Locate a centre detail page"
                                    :items="pages"
                                    v-model="fields.locate_a_centre_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.locate_a_centre_detail"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-select
                                    label="Locate a centre Thank You page"
                                    :items="pages"
                                    v-model="fields.locate_a_centre_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.locate_a_centre_thank_you"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Articles - landing page"
                                    :items="pages"
                                    v-model="fields.articles_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.articles_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Articles detail page"
                                    :items="pages"
                                    v-model="fields.articles_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.articles_detail"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Tyres Landing Thank You page"
                                    :items="pages"
                                    v-model="fields.tyres_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.tyres_thank_you"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Tyres Enquiry - landing page"
                                    :items="pages"
                                    v-model="fields.tyres_enquiry_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.tyres_enquiry_landing"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    label="Tyres Enqury Landing Thank You page"
                                    :items="pages"
                                    v-model="fields.tyres_enquiry_thank_you"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.tyres_enquiry_thank_you"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Franchise - landing page"
                                    :items="pages"
                                    v-model="fields.franchise_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.franchise_landing"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Make a booking - landing page"
                                    :items="pages"
                                    v-model="fields.make_a_booking_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.make_a_booking_landing"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Terms and conditions / terms of service - landing page"
                                    :items="pages"
                                    v-model="fields.terms_and_conditions_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.terms_and_conditions_landing"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Unsubscribe page"
                                    :items="pages"
                                    v-model="fields.unsubscribe_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.unsubscribe_landing"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Referral services"
                                    :items="pages"
                                    v-model="fields.referral_services_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.referral_services_landing"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Referral services"
                                    :items="pages"
                                    v-model="fields.referral_services_detail"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.referral_services_detail"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-select
                                    label="Website Cookie Preferences"
                                    :items="pages"
                                    v-model="fields.website_cookie_preferences_landing"
                                    preselect="&mdash; Please select &mdash;"
                                    :error="errors.website_cookie_preferences_landing"
                                />
                            </div>
                        </div>
                    </app-tabs-content>
                    <app-tabs-content name="theme" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-text
                                    label="Facebook URL"
                                    v-model="fields.theme.facebookURL"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-text
                                    label="Twitter URL"
                                    v-model="fields.theme.twitterURL"
                                />
                            </div>
                            <div class="w-full md:w-1/3 px-2">
                                <app-field-text
                                    label="YouTube URL"
                                    v-model="fields.theme.youtubeURL"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="ResponseTap ID"
                                    v-model="fields.theme.responsetap_id"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                           <div class="w-full md:w-1/2 px-2">
                               <app-field-file
                                   :required="false"
                                   label="'I want to' image"
                                   v-model="fields.theme.iWantToImage"
                                   helper=""
                                   :types="{images: true, files: false}"
                               />
                           </div>
                       </div>
                        <label class="label">Scripts</label>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-code
                                    label="Header Scripts - Strictly Necessary Cookies (before closing </head>)"
                                    v-model="fields.theme.headScriptsStrictly"
                                    mode="text/html"
                                />
                                <app-field-code
                                    label="Header Scripts - Performanace Cookies (before closing </head>)"
                                    v-model="fields.theme.headScriptsPerformance"
                                    mode="text/html"
                                />
                                <app-field-code
                                    label="Header Scripts - Functionality Cookies (before closing </head>)"
                                    v-model="fields.theme.headScriptsFunctionality"
                                    mode="text/html"
                                />
                                <app-field-code
                                    label="Header Scripts - Target and Advertising Cookies (before closing </head>)"
                                    v-model="fields.theme.headScriptsTargetAndAdvertising"
                                    mode="text/html"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-code
                                    label="Body Scripts - Strictly Necessary Cookies  (before closing </body>)"
                                    v-model="fields.theme.bodyScriptsStrictly"
                                    mode="text/html"
                                />
                                <app-field-code
                                    label="Body Scripts - Performance Cookies (before closing </body>)"
                                    v-model="fields.theme.bodyScriptsPerformance"
                                    mode="text/html"
                                />
                                <app-field-code
                                    label="Body Scripts - Functionality Cookies (before closing </body>)"
                                    v-model="fields.theme.bodyScriptsFunctionality"
                                    mode="text/html"
                                />
                                <app-field-code
                                    label="Body Scripts - Target and Advertising Cookies (before closing </body>)"
                                    v-model="fields.theme.bodyScriptsTargetAndAdvertising"
                                    mode="text/html"
                                />
                            </div>
                        </div>

                        <app-field-code
                            label="Overwriting CSS Styles"
                            v-model="fields.theme.styles"
                            mode="text/css"
                        />

                        <app-field-code
                            label="Copyright (footer text)"
                            v-model="fields.theme.copyright"
                            mode="text/html"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="info" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <app-field-toggle
                                :required="false"
                                label="Enable info box"
                                v-model="fields.info_box.enabled"
                            />
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <app-field-trix
                                :required="false"
                                label="Copy for info box"
                                v-model="fields.info_box.copy"
                            />
                        </div>
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CodeField from '@/components/fields/inputs/Code';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import TrixField from '@/components/fields/inputs/Trix';

    /* Builder components */
    import Builder from '@/components/composer/Builder';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'settings.edit',

        data: () => ({
            loading: true,
            settings: null,
            pages: [],
            fields: {
                site_title: '',
                default_language: '',
                homepage: '',
                services_landing: '',
                services_detail: '',
                services_thank_you: '',
                services_contact_thank_you: '',
                services_commercial_landing: '',
                services_commercial_detail: '',
                services_commercial_thank_you: '',
                services_commercial_contact_thank_you: '',
                offers_landing: '',
                offers_detail: '',
                offers_thank_you: '',
                careers_landing: '',
                careers_detail: '',
                locate_a_centre_landing: '',
                locate_a_centre_detail: '',
                locate_a_centre_thank_you: '',
                articles_landing: '',
                articles_detail: '',
                location_landing: '',
                tyres_thank_you: '',
                tyres_enquiry_landing: '',
                tyres_enquiry_thank_you: '',
                franchise_landing: '',
                make_a_booking_landing: '',
                terms_and_conditions_landing: '',
                unsubscribe_landing: '',
                referral_services_landing: '',
                services_services_detail: '',
                website_cookie_preferences_landing: '',
                theme: {
                    headScripts: '',
                    headScriptsStrictly: '',
                    headScriptsPerformance: '',
                    headScriptsFunctionality: '',
                    headScriptsTargetAndAdvertising: '',
                    bodyScriptsStrictly: '',
                    bodyScriptsPerformance: '',
                    bodyScriptsFunctionality: '',
                    bodyScriptsTargetAndAdvertising: '',
                    bodyScripts: '',
                    styles: '',
                    copyright: '',
                    facebookURL: '',
                    twitterURL: '',
                    youtubeURL: '',
                    responsetap_id: '',
                    iWantToImage: ''
                },
                info_box: {
                    enabled: false,
                    copy: ''
                }
            },
            items: {
                locales: []
            },
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-builder': Builder,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-code': CodeField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-field-trix': TrixField,
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            this.loading = true;

            this.getSettings()
                .then(response => {
                    this.loading = false;

                    this.setFields();

                    this.setLocales();
                });
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },

        methods: {
            getSettings() {
                return Api.request('get', `settings`)
                    .then(({ data }) => {
                        this.settings = data.settings;
                        this.pages    = data.pages;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `settings`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            setLocales() {
                if (this.locales.length > 0) {
                    this.locales.forEach(locale => {
                        this.items.locales.push({
                            label: locale.lang,
                            value: locale.id
                        });
                    });
                }
            },
            setFields() {
                this.fields.site_title                      = this.settings.site_title;
                this.fields.default_language                = this.settings.locale;
                this.fields.homepage                        = this.settings.pages.homepage;
                this.fields.services_landing                = this.settings.pages.services_landing;
                this.fields.services_detail                 = this.settings.pages.services_detail;
                this.fields.services_thank_you              = this.settings.pages.services_thank_you;
                this.fields.services_contact_thank_you      = this.settings.pages.services_contact_thank_you;
                this.fields.services_commercial_landing                = this.settings.pages.services_commercial_landing;
                this.fields.services_commercial_detail                 = this.settings.pages.services_commercial_detail;
                this.fields.services_commercial_thank_you              = this.settings.pages.services_commercial_thank_you;
                this.fields.services_commercial_contact_thank_you      = this.settings.pages.services_commercial_contact_thank_you;
                this.fields.offers_landing                  = this.settings.pages.offers_landing;
                this.fields.offers_detail                   = this.settings.pages.offers_detail;
                this.fields.offers_thank_you                = this.settings.pages.offers_thank_you;
                this.fields.careers_landing                 = this.settings.pages.careers_landing;
                this.fields.careers_detail                  = this.settings.pages.careers_detail;
                this.fields.locate_a_centre_landing         = this.settings.pages.locate_a_centre_landing;
                this.fields.locate_a_centre_detail          = this.settings.pages.locate_a_centre_detail;
                this.fields.locate_a_centre_thank_you       = this.settings.pages.locate_a_centre_thank_you;
                this.fields.articles_landing                = this.settings.pages.articles_landing;
                this.fields.articles_detail                 = this.settings.pages.articles_detail;
                this.fields.location_landing                = this.settings.pages.location_landing;
                this.fields.tyres_thank_you                 = this.settings.pages.tyres_thank_you;
                this.fields.tyres_enquiry_landing           = this.settings.pages.tyres_enquiry_landing;
                this.fields.tyres_enquiry_thank_you         = this.settings.pages.tyres_enquiry_thank_you;
                this.fields.franchise_landing               = this.settings.pages.franchise_landing;
                this.fields.make_a_booking_landing          = this.settings.pages.make_a_booking_landing;
                this.fields.terms_and_conditions_landing    = this.settings.pages.terms_and_conditions_landing;
                this.fields.unsubscribe_landing             = this.settings.pages.unsubscribe_landing;
                this.fields.referral_services_landing            = this.settings.pages.referral_services_landing;
                this.fields.referral_services_detail             = this.settings.pages.referral_services_detail;
                this.fields.website_cookie_preferences_landing   = this.settings.pages.website_cookie_preferences_landing;

                for(let key in this.fields.theme) {
                    if(typeof this.settings.theme[key] !== 'undefined') {
                        this.fields.theme[key] = this.settings.theme[key];
                    }
                }

                for(let key in this.fields.info_box) {
                    if(typeof this.settings.info_box[key] !== 'undefined') {
                        this.fields.info_box[key] = this.settings.info_box[key];
                    }
                }
            }
        },

        watch: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/settings/Home.vue